/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ template: NonNullable<unknown>, target: NonNullable<unknown> }} Template_Apply_Team_TextInputs */

const en_template_apply_team_text = /** @type {(inputs: Template_Apply_Team_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Do you really want to apply the template “${i?.template}” to the current members of the team “${i?.target}”? Settings and assignments of these users may change.`)
};

const de_template_apply_team_text = /** @type {(inputs: Template_Apply_Team_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchtest du die Vorlage „${i?.template}“ wirklich auf die aktuellen Mitglieder des Teams „${i?.target}“ anwenden? Dabei können Einstellungen und Zuordnungen dieser Benutzer geändert werden.`)
};

/**
* | output |
* | --- |
* | "Do you really want to apply the template “{template}” to the current members of the team “{target}”? Settings and assignments of these users may change." |
*
* @param {Template_Apply_Team_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const template_apply_team_text = /** @type {((inputs: Template_Apply_Team_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Template_Apply_Team_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_template_apply_team_text(inputs)
	return de_template_apply_team_text(inputs)
});